export default __webpack_public_path__ + "media/images/landlords_page/benefits_2-dd1eb5df3afdbe4361a1aae522972631.webp";